import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadService {

  constructor() { }

  download(url: string, fileName: string): void {
    const a = document.createElement('a')
    a.href = url
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }
}
